// extracted by mini-css-extract-plugin
module.exports = {"saveActions":"TeacherEdit_saveActions__7JCcb","saveActionsBack":"TeacherEdit_saveActionsBack__1MLK0"};